import React, { useState, useEffect, createContext, useMemo } from 'react';

import axios from 'axios';
import toast from 'react-hot-toast';
import CartData from './cartData';
import Loader from './loader';

import { link } from '../dynamic/api';

import { englishTabs, arabicTabs,
  arabicPages, englishPages, englishContent, arabicContent } from '../dynamic/languages';

export const DataContext = createContext();
export const CartContext = createContext();

function GetData(props) {

  const { setAccess, userName, token, expireyDate, localApi, serverApi, devSetting, session } = props;


  let api;
  if (!devSetting?.isServer && userName !== 'dev') {  
    api = serverApi;
  } else {
    api = localApi;
  }

  const sessionId = session?.id;

  const [loaderEffect, setLoaderEffect] = useState(true);


  const [salableData, setSalableData] = useState([]);

  const [productData, setProductData] = useState([]);
  const [refProduct, setRefProduct] = useState([]);

  const [accountData, setAccountData] = useState([]);


  const [settingData, setSettingData] = useState(0);
  const [refSetting, setRefSetting] = useState(0);



  const [deliveryData, setDeliveryData] = useState([]);

  const [tablesData, setTablesData] = useState([]);
  const [refTablesData, setRefTablesData] = useState([]);


  const [printerData, setPrinterData] = useState([]);
  const [refPrinter, setRefPrinter] = useState([]);
  const [allPrinterData, setAllPrinterData] = useState([]);

  const [userData, setUserData] = useState('');

  const [allUserData, setAllUserData] = useState([]);

  const [wholeSale, setWholeSale] = useState('');

  //new Edition
  const [chartData, setChartData] = useState([]);

  const [devData, setDevData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [roleData, setRoleData] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [wareHouseData, setWareHouseData] = useState([]);


  // Data to get
  useEffect(() => {
    refDevData();
  }, []);


  const refreshProduct = () => {
    setRefProduct(!refProduct)
  }

  const refreshPrinter = () => {
    setRefPrinter(!refPrinter)
  }

  const refreshTables = () => {
    setRefTablesData(!refTablesData)
  }

  const refreshSetting = () => {
    setRefSetting(!refSetting)
  }





  // Get Printer Data
  useEffect(() => {
    const fetchData = async () => {
      try {
        let data = { isActive: true };
        const response = await api.get(`/printer/getAll`, { params: data });
        if (response) {
          setPrinterData(response.data.data);
        }
      } catch (error) {
        toast.error('' + error);
      }
    };
    fetchData();
  }, [refPrinter]);




  // Get Tables Data
  useEffect(() => {
    const fetchData = async () => {
      try {
        let data = { isActive: true };
        const response = await api.get(`/tables/getAll`, { params: data });
        if (response) {
          setTablesData(response.data.data);
        }
      } catch (error) {
        toast.error('' + error);
      }
    };
    fetchData();
  }, [refTablesData]);



  // Tempor run
  useEffect(() => {
    refWareHouseData();
    refCategory();
  }, []);


  // Get All User Data
  const refAllUserData = async () => {
    try {
      const data = { filter: { isActive: 'true' } };
      const response = await api.get(`/printer/getAll`, { params: data });
      if (response) {
        setAllPrinterData(response.data.data);
      }
    } catch (error) {
      toast.error('' + error);
    }
  };

  useEffect(() => {
      const fetchData = async () => {
          try {
              // Check if api is available before making a call
              if (!api) return; 
              let data = { userName: userName };
              const response = await api.get(`/user/getUser`, { params: data });
              if (response) {
                  setUserData(response.data.data);
              }
          } catch (error) {
              toast.error('' + error);
          }
      };
      fetchData();
  }, [api, userName]);


  const refAllPrinter = async () => {
    try {
      const data = { filter: { isActive: 'true' } };
      const response = await api.get(`/user/getAll`, { params: data });
      if (response) {
        setAllUserData(response.data.data);
      }
    } catch (error) {
      toast.error('' + error);
    }
  };




    // Get Role
    const refRole = async () => {
      try {
        let data = { filter: { isActive: 'true' } };
        const response = await api.get(`/role/getAll`, { params: data });
        if (response) {
          setRoleData(response.data.data);
        }
      } catch (error) {
        toast.error('' + error);
      }
    };
  


  // Get Category
  const refCategory = async () => {
    try {
      let data = { filter: { isActive: 'true' } };
      const response = await api.get(`/category/getAll`, { params: data });
      if (response) {
        setCategoryData(response.data.data);
      }
    } catch (error) {
      toast.error('' + error);
    }
  };




  // Get User Data
  useEffect(() => {
    const fetchData = async () => {
      try {
        let data = { userName: userName };
        const response = await api.get(`/user/getUser`, { params: data });
        if (response) {
          setUserData(response.data.data);
        }
      } catch (error) {
        toast.error('' + error);
      }
    };
    fetchData();
  }, []);



  //Ref Account data
  const refAccountData = async (type) => {
    try {
      let data = { filter: { isActive: 'true', isDropDown: 'true' , type: type} };
      const response = await api.get(`/account/getAll`, { params: data });
      if (response) {
        setAccountData(response.data.data);
      }
    } catch (error) {
      toast.error('' + error);
    }
  };

  //Ref Delivery data
  const refDeliveryData = async () => {
    try {
      let data = { filter: { isActive: 'true' } };
      const response = await api.get(`/delivery/getAll`, { params: data });
      if (response) {
        setDeliveryData(response.data.data);
      }
    } catch (error) {
      toast.error('' + error);
    }
  };


  //Ref product data
  const refProductData = async () => {
    try {
      let data = { filter: { isActive: 'true' } };
      const response = await api.get(`/product/getAll`, { params: data });
      if (response) {
        setProductData(response.data.data);
      }
    } catch (error) {
      toast.error('' + error);
    }
  };

  // Get wareHouses
  const refWareHouseData = async () => {
    try {
      let data = { filter: { isActive: 'true' } };
      const response = await api.get(`/wareHouse/getAll`, { params: data });
      if (response) {
        setWareHouseData(response.data.data);
      }
    } catch (error) {
      toast.error('' + error);
    }
  };




  // Get Settings
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get(`/Setting/getAll`);
        if (response) {
          setSettingData(response.data.data[0]);
        }
      } catch (error) {
        toast.error('' + error);
      }
    };
    fetchData();
  }, [refSetting]);



const refSalableData = async (wholeSale) => {
    if (userData && settingData) {
      let data = {
        filter: {
          isActive: true,
          wareHouseId: userData.role.wareHouseSaleId,
        },
      };
      await api.get(`/product/getSalable`, { params: data }).then((results) => {
        if (results) {
          let products = results.data.data;

          // If useBranchPrice is enabled, override default prices with branch prices
          if (settingData.useBranchPrice) {
            products = products.map((product) => {
              // Check if stock info and a branch-specific price exist
              if (product.stocks && product.stocks.length > 0 && product.stocks[0].price !== null) {
                // Return a new product object with updated prices
                return {
                  ...product,
                  price: product.stocks[0].price,
                  wholeSalePrice: product.stocks[0].wholeSalePrice,
                  cost: product.stocks[0].cost,
                };
              }
              // Return the original product if no branch price is found
              return product;
            });
          }

          // After potentially updating to branch prices, handle the wholesale logic
          if (wholeSale) {
            products.forEach((item) => {
              // Use the item's wholesale price (which could be the branch's wholesale price now)
              item.price = item.wholeSalePrice;
            });
          }
          setSalableData(products);
        }
      }).catch((error) => {
        toast.error('' + error);
      });
    }
  };



  // Chart Data
  const refChartData = async (search) => {
    try {
      let data = { filter: { search: search } };
      const response = await api.get(`/chart/getAll`, { params: data });
      if (response) {
        setChartData(response.data.data);
      }
    } catch (error) {
      toast.error('' + error);
    }
  };


  // Get DevData using localApi
  const refDevData = async () => {
    try {
      let data = { isActive: true };
      const response = await localApi.get(`/dev/getAll`, { params: data });
      if (response) {
        setDevData(response.data.data[0]);
      }
    } catch (error) {
      toast.error('' + error);
    }
  };

    const menuTabs = useMemo(() => {
    const tabsMap = {
      english: englishTabs,
      arabic: arabicTabs,
    };

    return tabsMap[settingData?.language] || englishTabs;
  }, [settingData?.language]);

  const menuPages = useMemo(() => {
    const pagesMap = {
      english: englishPages,
      arabic: arabicPages,
    };

    return pagesMap[settingData.language] || englishPages;
  }, [settingData?.language]);

  const contentLanguages = useMemo(() => {
    const pagesMap = {
      english: englishContent,   
      arabic: arabicContent,
    };

    return pagesMap[settingData.language] || englishContent;
  }, [settingData?.language]);  



  return (
    <div>

      <DataContext.Provider
        value={{
          setLoaderEffect,
          expireyDate,
          api,
          userData,
          productData,
          refreshProduct,

          settingData,
          refreshSetting,
          roleData,
          setAccess,

          tablesData,
          refreshTables,
          printerData,
          refreshPrinter,

          // new structure
          refChartData,
          chartData,

          salableData,
          refSalableData,

          devData,
          refDevData,

          serverApi,
          localApi,

          categoryData,
          refCategory,

          roleData,
          refRole,

          refProductData,
          productData,

          wareHouseData,
          refWareHouseData,


          accountData,
          refAccountData,

          refDeliveryData,
          deliveryData,

          refAllUserData,
          allUserData,

          refAllPrinter,
          allPrinterData,

          devSetting,

           //language
            menuTabs,
            menuPages,
            contentLanguages,

          session,
          sessionId,



        }}>


        {loaderEffect &&
          <Loader />
        }


        {userData && settingData &&
          <CartData setAccess={setAccess} settingData={settingData} userData={userData} />
        }



      </DataContext.Provider>




    </div>

  );
}


export default GetData;